import { TratamentoFormValue } from '../../../../@types';
import makeForm from '../../../../components/Form';
import Yup from '../../../../utils/yup';
import { isSegundoTratamento } from '../utils';

export const validationSchema = Yup.object().shape({
  dataInicio: Yup.date().required(),
  dataFim: Yup.date()
    .required()
    .min(Yup.ref('dataInicio'), 'Não pode ser menor que a data inicial'),
  sementeOrigem: Yup.object().required(),
  sementeDestino: Yup.object().required(),
  quantidade: Yup.number().when(
    ['sementeOrigem', 'sementeDestino'],
    ([sementeOrigem, sementeDestino], schema) =>
      isSegundoTratamento({ sementeOrigem, sementeDestino })
        ? schema.notRequired()
        : schema.required().moreThan(0),
  ),
  unidade: Yup.object().when(
    ['sementeOrigem', 'sementeDestino'],
    ([sementeOrigem, sementeDestino], schema) =>
      isSegundoTratamento({ sementeOrigem, sementeDestino })
        ? schema.notRequired()
        : schema.required(),
  ),
  pms: Yup.number().when(
    ['sementeOrigem', 'sementeDestino', 'unidade'],
    ([sementeOrigem, sementeDestino, unidade], schema) =>
      !isSegundoTratamento({ sementeOrigem, sementeDestino }) &&
      unidade?.taxaSementes > 0
        ? schema.required().moreThan(0)
        : schema.notRequired(),
  ),
  peso: Yup.number().when(
    ['sementeOrigem', 'sementeDestino', 'unidade'],
    ([sementeOrigem, sementeDestino, unidade], schema) =>
      !isSegundoTratamento({ sementeOrigem, sementeDestino }) &&
      unidade?.taxaSementes > 0
        ? schema.required().moreThan(0)
        : schema.notRequired(),
  ),
  copiarDeOutraSemente: Yup.object(),
  search: Yup.object(),
  defensivos: Yup.array().when(
    ['sementeOrigem', 'sementeDestino'],
    ([sementeOrigem, sementeDestino], schema) =>
      schema.of(
        Yup.object().shape({
          item: Yup.object().required(),
          dose: isSegundoTratamento({ sementeOrigem, sementeDestino })
            ? Yup.number().notRequired()
            : Yup.number().required().moreThan(0),
          quantidade: isSegundoTratamento({
            sementeOrigem,
            sementeDestino,
          })
            ? Yup.number().required().moreThan(0)
            : Yup.number().notRequired(),
        }),
      ),
  ),
});

export const defaultValues: TratamentoFormValue = {
  dataInicio: undefined,
  dataFim: undefined,
  sementeOrigem: undefined,
  sementeDestino: undefined,
  quantidade: undefined,
  unidade: undefined,
  pms: undefined,
  peso: undefined,
  copiarDeOutraSemente: undefined,
  search: undefined,
  defensivos: [],
  identification: undefined,
};

export const FormDialog = makeForm<TratamentoFormValue>();
